export default "__VITE_ASSET__2e9306e9__"